/* bf26g-gift-tip.js (9 Oct 2026) - explains the Mystery gift perk.
   1) Accessible tooltip on the Mystery gift rung of every ladder bar (small ? button on the bubble) and on the "?" gift thumbnail in the Bundle Builder strip.
      Opens on hover, keyboard focus, or click/tap; closes on Esc, outside click, scroll or blur. The trigger points at the tooltip with aria-describedby.
   2) "Add another" button of the cart drawer gift note (snippets/bf26g-gift-note.liquid): POST /cart/add.js, then refresh the native drawer.
   Copy comes from #bf26g-gift-tip-data (sections/bf26g-ladder-data.liquid settings; blank text = first paragraph of the Mystery Gift product description).
   Display only: never touches the ladder maths, the 3-piece gate or the cart perks code.
   r53 (15 Oct 2026): no "?" button on the Mystery gift rung any more (DESIGN.md 1.4: no "?" icons). The unlock step for the tip text comes from the engine
   (bf26gLadder.giftAt). "Add another" re-renders through window.RKCart (assets/bf26y-giftguard.js), the one drawer re-render helper. */
(function () {
  'use strict';
  if (window.__bf26gTip) return;
  window.__bf26gTip = 1;
  var D = {};
  try { D = JSON.parse(document.getElementById('bf26g-gift-tip-data').textContent) || {}; } catch (e) {}
  var ID = 'bf26g-gift-tip', tip = null, cur = null, timer = 0, qt = 0, minN = 0;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function build() {
    if (tip) return;
    tip = document.createElement('div');
    tip.id = ID; tip.className = 'bf26g-tip'; tip.setAttribute('role', 'tooltip'); tip.hidden = true;
    tip.addEventListener('mouseenter', function () { clearTimeout(timer); });
    tip.addEventListener('mouseleave', sched);
    document.body.appendChild(tip);
  }
  function fill() {
    var m = minN && D.mechanic ? String(D.mechanic).replace('{n}', minN) : '';
    tip.innerHTML = '<p class="bf26g-tip__t">' + esc(D.title || 'Mystery gift') + '</p>' + (D.text ? '<p class="bf26g-tip__p">' + esc(D.text) + '</p>' : '') + (m ? '<p class="bf26g-tip__m">' + esc(m) + '</p>' : '') + (D.url ? '<a href="' + esc(D.url) + '">' + esc(D.linkLabel || 'Read more') + '</a>' : '');
  }
  function place() {
    if (!cur || !tip) return;
    var r = cur.getBoundingClientRect(), vw = document.documentElement.clientWidth, w = Math.min(280, vw - 24);
    tip.style.width = w + 'px';
    var left = Math.max(12, Math.min(vw - w - 12, r.left + r.width / 2 - w / 2)), h = tip.offsetHeight, top = r.bottom + 8;
    if (top + h > window.innerHeight - 8 && r.top - h - 8 > 8) top = r.top - h - 8;
    tip.style.left = left + 'px'; tip.style.top = Math.max(8, top) + 'px';
  }
  function open(el) {
    build(); clearTimeout(timer);
    if (cur && cur !== el) cur.setAttribute('aria-expanded', 'false');
    cur = el; fill(); tip.hidden = false; el.setAttribute('aria-expanded', 'true'); place();
  }
  function close(back) {
    clearTimeout(timer);
    if (!cur) return;
    var el = cur; cur = null; tip.hidden = true; el.setAttribute('aria-expanded', 'false');
    if (back) { try { el.focus(); } catch (e) {} }
  }
  function sched() { clearTimeout(timer); timer = setTimeout(function () { close(false); }, 180); }
  function trig(t) { return t && t.closest ? t.closest('[data-gtip-btn]') : null; }

  function enhance() {
    if (!minN && window.bf26gLadder && window.bf26gLadder.giftAt) minN = window.bf26gLadder.giftAt() || 0;
    var th = document.querySelectorAll('.bbu-th--gift:not([data-gtip-btn])');
    for (var j = 0; j < th.length; j++) {
      var t = th[j];
      t.setAttribute('data-gtip-btn', '1'); t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0');
      t.setAttribute('aria-describedby', ID); t.setAttribute('aria-expanded', 'false'); t.removeAttribute('title');
    }
  }
  function queue() { if (!qt) qt = setTimeout(function () { qt = 0; enhance(); }, 30); }
  try { new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  enhance();

  document.addEventListener('mouseover', function (e) { var t = trig(e.target); if (t && window.matchMedia && window.matchMedia('(hover:hover)').matches) open(t); });
  document.addEventListener('mouseout', function (e) { if (trig(e.target) && cur) sched(); });
  document.addEventListener('focusin', function (e) { var t = trig(e.target); if (t && t.matches && t.matches(':focus-visible')) open(t); });
  document.addEventListener('focusout', function (e) { if (trig(e.target) && cur && !(tip && tip.contains(e.relatedTarget))) sched(); });
  document.addEventListener('click', function (e) {
    var t = trig(e.target);
    if (t) { e.preventDefault(); e.stopPropagation(); if (cur === t && !tip.hidden) close(false); else open(t); return; }
    if (cur && tip && !tip.contains(e.target)) close(false);
    var a = e.target.closest ? e.target.closest('[data-bf26g-gn-add]') : null;
    if (a) add(a);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (cur && e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
    var t = trig(e.target);
    if (t && t.getAttribute('role') === 'button' && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (cur === t && !tip.hidden) close(false); else open(t); }
  }, true);
  window.addEventListener('scroll', function () { if (cur) close(false); }, true);
  window.addEventListener('resize', function () { if (cur) close(false); });

  /* ---- cart drawer gift note: add another ---- */
  function add(btn) {
    if (btn.disabled) return;
    var id = +btn.getAttribute('data-bf26g-gn-add'), msg = btn.parentNode && btn.parentNode.parentNode.querySelector('[data-gn-msg]');
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (r) {
        if (!r.ok) { btn.disabled = false; if (msg) msg.textContent = r.d && r.d.description ? r.d.description : 'Could not add it just now.'; return; }
        if (window.RKCart && window.RKCart.render) window.RKCart.render(r.d.sections || {});
        else if (window.BF26Cart && window.BF26Cart.drawer) window.BF26Cart.drawer(r.d);
        else {
          var S = r.d.sections || {}, old = document.getElementById('CartDrawer');
          if (S['cart-drawer'] && old) { var nw = new DOMParser().parseFromString(S['cart-drawer'], 'text/html').getElementById('CartDrawer'); if (nw) old.innerHTML = nw.innerHTML; }
        }
        if (window.bf26gLadder && window.bf26gLadder.refresh) window.bf26gLadder.refresh();
      })
      .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Could not add it just now.'; });
  }
})();
